export default __webpack_public_path__ + "1e4905a1997e00aabd3d36123fe079ff.png";